import { textBoxRequiredControl } from '../../../../../constants/form-control/core/common/textbox/textbox-required';
import { FormControlUtil } from '../../../../../core/utils/form-control';

export const ShouldEndShiftConstant = {
  timesheet_form_pending_reason: FormControlUtil.mergeFormControl(textBoxRequiredControl, {
    key: 'timesheet_form_pending_reason',
    templateOptions: FormControlUtil.mergeFormControl(textBoxRequiredControl.templateOptions, { label: 'Form Pending Reason' }),
  }),
  timesheet_task_pending_reason: FormControlUtil.mergeFormControl(textBoxRequiredControl, {
    key: 'timesheet_task_pending_reason',
    templateOptions: FormControlUtil.mergeFormControl(textBoxRequiredControl.templateOptions, { label: 'Task Pending Reason' }),
  }),
  // timesheet_loop_pending_reason: FormControlUtil.mergeFormControl(textBoxRequiredControl, {
  //   key: 'timesheet_loop_pending_reason',
  //   templateOptions: FormControlUtil.mergeFormControl(textBoxRequiredControl.templateOptions, { label: 'Loop Pending Reason' }),
  // }),
  timesheet_patrol_pending_reason: FormControlUtil.mergeFormControl(textBoxRequiredControl, {
    key: 'timesheet_patrol_pending_reason',
    templateOptions: FormControlUtil.mergeFormControl(textBoxRequiredControl.templateOptions, { label: 'Patrol Pending Reason' }),
  }),
};